import Config from '@config';
import { initializeAddressesApi } from '@gasbi/shared';
import { SettlementType, StreetType } from '@gasbi/shared/common/features';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

const addressesApiObject = initializeAddressesApi({
  baseUrl: Config.VITE_API_URL,
  baseQuery: axiosBaseQuery,
});

export const {
  addressesApi,
  useGetBuildingNumbersQuery,
  useGetSettlementsIInfiniteQuery,
  useGetStreetIInfiniteQuery,
} = addressesApiObject;

// Mirrors Gasbi.Addresses.Shared.Contracts.Models.AddressModel — needed to reverse-populate
// AddressForm's cascading pickers (settlement/street/building autocomplete labels, not just ids)
// from an already-resolved SupplyAddressId, same as PrivateConsumers' own AddressDetailsModel.
export interface AddressDetailsModel {
  id: string;
  settlementId: string;
  streetId: string;
  settlement: string;
  street: string;
  oldStreet?: string | null;
  streetType: StreetType;
  settlementType: SettlementType;
  buildingNumber: string;
  region?: string | null;
  district?: string | null;
  community?: string | null;
  postalCode?: string | null;
  fullAddress: string;
}

const extendedAddressesApi = addressesApi.injectEndpoints({
  endpoints: builder => ({
    getAddressById: builder.query<AddressDetailsModel, string>({
      query: id => ({ url: `${id}`, method: 'GET' }),
    }),
  }),
});

export const { useGetAddressByIdQuery } = extendedAddressesApi;
